import { window } from "global";
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { parseQueryString } from "@ugg/shared/utils/url-query-params";
import { getSameOriginPath } from "@ugg/shared/utils/safe-redirect";
import { AppRoutes } from "@ugg/shared/routes/app-routes";
import { AccountLandingPageContent, AccountLandingPageLayout } from "@ugg/shared/components/auth/AccountLandingPageLayout";
import { SignupForm } from "@ugg/shared/components/auth/SignupForm";
import { SignupFormFooter } from "@ugg/shared/components/auth/SignupFormFooter";
import { TermsDisclaimer } from "@ugg/shared/components/auth/TermsDisclaimer";
import { useCreateSupabaseAccountMutation } from "@ugitgud/legos/queries/auth";
import { useSiteOAuth } from "lib/hooks/use-site-oauth";

export const Signup = () => {
  const location = useLocation();
  const parsedQueryString = parseQueryString(location.search.substring(1));
  const isFromCheckout = parsedQueryString.continue?.startsWith(AppRoutes.CHECKOUT);

  useEffect(() => {
    window?.scrollTo(0, 0);
  }, []);

  const continueTo = getSameOriginPath(parsedQueryString.redirect_url || parsedQueryString.continue, AppRoutes.HOME);
  const oauth = useSiteOAuth(continueTo);
  const [createSupabaseAccount] = useCreateSupabaseAccountMutation();

  // Full navigation rather than history.push: the Apollo cache was populated while signed out,
  // so a reload is the cheapest way to refetch everything against the new session.
  const onSignedUp = async () => {
    await createSupabaseAccount().catch(console.error);
    window.location.href = continueTo;
  };

  return (
    <AccountLandingPageLayout game={parsedQueryString.game}>
      <Helmet>
        <title>U.GG - Signup</title>
      </Helmet>
      <AccountLandingPageContent
        backLink={
          <Link to={isFromCheckout ? AppRoutes.PLUS : AppRoutes.HOME}>
            &lt; {isFromCheckout ? "Back to PLUS" : "Back to Home"}
          </Link>
        }
      >
        <SignupForm onSignedUp={onSignedUp} subheading={isFromCheckout ? "to Unlock U.GG PLUS" : "to Get Started"}>
          <SignupFormFooter
            logInTo={AppRoutes.LOGIN + location.search}
            onOAuth={oauth.authenticate}
            oauthDisabled={oauth.isPending}
            oauthError={oauth.error}
          />
        </SignupForm>
        <TermsDisclaimer termsUrl={AppRoutes.TOS} privacyUrl={AppRoutes.PRIVACY_POLICY} />
      </AccountLandingPageContent>
    </AccountLandingPageLayout>
  );
};

export default Signup;
